import { XImageRender } from "@platformx/x-image-render";
import HiddenTextBox from "../HiddenTextBox/HiddenTextBox";

const ImagePickerWithoutCrop = ({
  field,
  error,
  register,
  data,
  updateField,
  containerSize,
  aspect_ratio,
  isDisabled = false,
}: any) => {
  return (
    <div
      id={`${field?.name}_id`}
      style={isDisabled ? { pointerEvents: "none", opacity: 0.6 } : undefined}>
      {/* This is the id that is used to scroll to the error */}
      <XImageRender
        callBack={updateField}
        editData={{
          original_image: data?.original_image,
          published_images: data?.published_images,
          relativeUrl: data?.relativeUrl,
        }}
        isCrop={false}
        name={field?.name}
        containerSize={containerSize}
        aspect_ratio={aspect_ratio}
      />
      <HiddenTextBox
        error={error}
        value={data?.original_image?.Thumbnail}
        register={register}
        name={field?.name}
        required={
          field?.validations?.length > 0 &&
          field?.validations[0]?.type === "required" &&
          !data?.original_image?.Thumbnail
            ? field?.validations[0]?.message
            : ""
        }
      />
    </div>
  );
};
export default ImagePickerWithoutCrop;
